import { TextField } from "@fluentui/react";
import React, { useState } from "react";
import { localize } from "src/l10n";

export const REPORT_COMMENT_MAX_LENGTH = 1000;

interface IProps {
    onChange: (value: string) => void;
}

const ReportContentField = ({ onChange }: IProps) => {
    const [value, setValue] = useState("");

    return (
        <TextField
            className="ReportContentField"
            label={localize("COMMENT")}
            multiline
            autoAdjustHeight
            resizable={false}
            value={value}
            maxLength={REPORT_COMMENT_MAX_LENGTH}
            onChange={(_, newValue) => {
                const nextValue = (newValue || "").substring(0, REPORT_COMMENT_MAX_LENGTH);
                setValue(nextValue);
                onChange(nextValue);
            }}
        />
    );
};

export default ReportContentField;
